// ThemeContext.js
import React, { createContext, useState, useContext, useEffect } from 'react';

const ThemeContext = createContext();

export const useTheme = () => useContext(ThemeContext);

export const ThemeProvider = ({ children }) => {
  const [isDarkMode, setIsDarkMode] = useState(() => {
    const savedMode = localStorage.getItem('modoOscuro');
    if (savedMode !== null) return savedMode === '1';
    const userStr = localStorage.getItem('user');
    if (userStr) {
      try {
        const user = JSON.parse(userStr);
        return user.modoOscuro === 1;
      } catch (e) {
        return false;
      }
    }
    return false;
  });

  const toggleDarkMode = (value) => {
    setIsDarkMode(value);
    localStorage.setItem('modoOscuro', value ? '1' : '0');
    
    // Disparar evento personalizado
    window.dispatchEvent(new CustomEvent('themeChange', { 
      detail: { modoOscuro: value ? 1 : 0 } 
    }));
  };

  return (
    <ThemeContext.Provider value={{ isDarkMode, toggleDarkMode }}>
      {children}
    </ThemeContext.Provider>
  );
};